import LegalLayout, { LegalSection } from "@/components/landing/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      title="Terms of Service"
      intro="Last updated: August 2026 — the terms that govern Revanta Asset Management' collection, destruction, and buyback services."
      testId="terms-page"
    >
      <LegalSection title="1. About these terms">
        <p>
          These terms govern the IT asset disposition (ITAD), e-waste collection, data
          destruction, and asset buyback services provided by Revanta Asset Management ("we", "us")
          to businesses across Australia. By booking a collection or using this website, you agree to
          these terms.
        </p>
      </LegalSection>

      <LegalSection title="2. Quotes and bookings">
        <p>
          Pickup estimates provided through this website are indicative only and confirmed once we
          assess your equipment. Free corporate collections require a minimum of five high-value
          items; smaller loads may attract a collection fee, which we will always confirm with you
          before proceeding. We aim to respond to all requests within 24 hours.
        </p>
      </LegalSection>

      <LegalSection title="3. Your responsibilities">
        <ul className="list-disc space-y-1.5 pl-5">
          <li>You confirm you own, or are authorised to dispose of, all equipment handed over</li>
          <li>You will describe the equipment accurately when booking</li>
          <li>You are responsible for backing up any data you wish to keep before collection</li>
          <li>You will provide safe and reasonable access to your premises for our team</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Data destruction">
        <p>
          Data-bearing devices are sanitised using industry-standard wiping methods or physically
          destroyed, and a Certificate of Data Destruction is issued on completion. Once assets
          are collected and processing has begun, data recovery is not possible.
        </p>
      </LegalSection>

      <LegalSection title="5. Asset buyback program">
        <p>
          Buyback valuations are made at our discretion following physical inspection of the
          assets and may differ from any initial estimate. Payment is made after data destruction
          and grading are complete, to the account details you nominate.
        </p>
      </LegalSection>

      <LegalSection title="6. Title and risk">
        <p>
          Ownership of collected assets passes to us upon collection, unless otherwise agreed in
          writing (for example, under a consignment or buyback arrangement).
        </p>
      </LegalSection>

      <LegalSection title="7. Liability">
        <p>
          To the maximum extent permitted by law, our liability is limited to the value of the
          services supplied, and we are not liable for indirect or consequential loss. Nothing in
          these terms excludes rights you have under the Australian Consumer Law.
        </p>
      </LegalSection>

      <LegalSection title="8. Environmental commitment">
        <p>
          We operate a zero-landfill policy: collected equipment is refurbished for reuse wherever
          possible and otherwise recycled through partners aligned with AS/NZS 5377, in compliance
          with NSW EPA requirements.
        </p>
      </LegalSection>

      <LegalSection title="9. Governing law">
        <p>
          These terms are governed by the laws of New South Wales, Australia, and the courts of
          NSW have exclusive jurisdiction.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact">
        <p>
          Questions about these terms? Contact us at karan@revantaassetmanagement.com or
          +61 466 426 343.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
